import { Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { BookCrdtnoteRcptComponent } from '../pages/book-crdtnote-rcpt/book-crdtnote-rcpt.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToWords } from 'to-words';
import { CommonModule, DatePipe } from '@angular/common';

@Component({
  selector: 'app-book-credit-note-register',
  templateUrl: './book-credit-note-register.component.html',
  styleUrl: './book-credit-note-register.component.scss',
  providers: [DatePipe]

})
export class BookCreditNoteRegisterComponent {
  crdtNoteData;
  BookBillingData;
  selectedBooks;
  crdtnotetotal;
  toWords;
  crdtnotetotalwords;
  totalamount = 0;
  crdtnoteamttotal = 0;
  remainingTotal = 0;
  address;
  bookcreditdata;
  crdreturncopies = 0
  payloadArray;
  receiptdata;
  crdtnote_no;
  data:any;

  crdtnotedata:any;
  creditNoteList :any;

  constructor(
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<BookCrdtnoteRcptComponent>,
    @Inject(MAT_DIALOG_DATA) public dataa: any
  ) {
    console.log('bookcrdtnote data', this.dataa);
  }

ngOnInit(): void {
  this.crdtNoteData = this.dataa['receiptdata'];
  this.crdtnote_no = this.crdtNoteData.map(item => item.crdtnote_no);

  this.service.getBookCrdtwise(this.crdtnote_no).subscribe((res) => {

    this.creditNoteList = (res as any[]).map(note => {

      const total = note.crdtnote_no_data.reduce((sum, item) => {
        return sum + parseFloat(item.crdtnote_total || 0);
      }, 0);

      this.toWords = new ToWords();
      const totalInWords = this.toWords.convert(total, { currency: true });

      // 🔹 build address for first row (same seller)
      const addressObj = note.crdtnote_no_data[0];

      const fullAddress = this.buildFullAddress(addressObj);

      return {
        ...note,
        totalAmount: total,
        crdtnotetotalwords: totalInWords,
        fullAddress: fullAddress   // ✅ final printable address
      };
    });

  });
}
buildFullAddress(item: any): string {
  const parts = [
    item.receiver_address,
    item.taluka,
    item.district,
    item.state,
    item.country,
    //  item.mobile_no
  ];

  // remove null / empty values
  return parts
    .filter(p => p && p.trim() !== '')
    .join(', ');
}


  print(): void {
    window.print();
  }

  
  ConvertToInt(val) {
    return parseInt(val);
  }
}
